/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';
import { defaultState } from 'app/redux/defaultState.js';
import Utilities from 'app/utility/Utilities.js';


export const socialLogins = (state = defaultState.socialLogins, action) => {
    let nextState = Utilities.deepClone(state);

    if (action.status === constants.STATE_SUCCESS) {
        switch (action.type) {
            case constants.SOCIAL_LOGIN_LIST:
            case constants.SOCIAL_LOGIN_CREATE:
            case constants.SOCIAL_LOGIN_DELETE:
                nextState = action.payload;
                break;

            default:
                break;

        }
    }

    return nextState;
};
